type PageHeaderProps = {
  title: string;
  description: string;
};

export default function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <div className="min-w-0 flex-1 flex flex-col items-center">
      <h1 className="text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
        {title}
      </h1>
      <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6 max-w-3xl">
        <div className="mt-2 flex items-center text-sm text-gray-500">
          {description}
        </div>
      </div>
    </div>
  );
}
